import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
            primary: '#6f006f',
            secondary: '#006f6f',
            accent: '#6f6f00',
            error: '#6f0038',
            excel: '#006f00'
            },
        },
    },
});
